import { Button } from '../../Components/ui/button'
import { useNavigate } from 'react-router-dom'
import { isDematUser } from '../../utils/AuthUtil'
import FullPagePopupLayout from '../../Components/Popups/FullPagePopupLayout'

const CompletionPopup = ({ isOpen, onClose, setIsPopupOpen }) => {
  const navigate = useNavigate()
  const actionLabel = isDematUser() ? 'Close' : 'Complete your KYC'

  return (
    <FullPagePopupLayout
      isOpen={isOpen}
      onClose={onClose}
      severity='success'
      title='Questionnaire Completed'
      message='Thank you for your time. We will contact you within 24 to 48 hours.'
      actionsClassName='fabits-global-popup-actions-single'
      actions={
        <Button
          onClick={() => {
            setIsPopupOpen(false)
            navigate('/dashboard')
          }}
          className='fabits-global-popup-button fabits-global-popup-button-primary'
        >
          {actionLabel}
        </Button>
      }
    >
      <p className='fabits-global-popup-supporting'>
        Your answers help the team prepare more relevant investment ideas before they reach out.
      </p>
    </FullPagePopupLayout>
  )
}

export default CompletionPopup
